module.exports = __webpack_public_path__ + "img/QuoteBG2.3643f6ef.jpeg";